const numberFormatter = new Intl.NumberFormat("ja-JP");
export const formatNumber = (number: number): string => {
  return numberFormatter.format(number);
};
